<template>
  <div class="position-line-menu">
    <MenuIcon
      :dropdownItems="visibleMenuItems"
      @onClick="handleMenuClick"
      :menuWidth="true"
      :isOpen="menuOpen"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import MenuIcon from "@components/MenuIcon/MenuIcon.vue";

const props = defineProps({
  position: { type: Object, required: true },
  status: { type: String, default: "Draft" },
  menuOpen: { type: Boolean, default: false },
});

const emit = defineEmits(["action"]);

function positionBlocksRetire(position) {
  const p = position || {};
  if (p.occupied_by != null && p.occupied_by !== "") return true;
  if (Array.isArray(p.assigned_employees) && p.assigned_employees.length > 0) return true;
  const primary = p.assigned_primary;
  if (primary && primary.assigned_employee_id != null) return true;
  if (Array.isArray(p.preparing_for) && p.preparing_for.length > 0) return true;
  if (Array.isArray(p.assigned_preparing_for) && p.assigned_preparing_for.length > 0) return true;
  return false;
}

const RETIRE_BLOCKED_TOOLTIP =
  "This position is linked to a role & assigned to Employee. Detach it first to retire";

const visibleMenuItems = computed(() => {
  const status = props.status;
  const isArchived = String(status || "").toLowerCase() === "archived";
  const position = props.position || {};
  const retireBlocked = positionBlocksRetire(position);

  return [
    // Activate/Delete: status = Draft
    status === "Draft" && {
      name: "Activate",
      value: "activate",
      icon: "icons/dropdown/activate.svg",
    },
    status === "Draft" && {
      name: "Delete",
      value: "delete",
      icon: "icons/dropdown/trash.svg",
      destructive: true,
      negative: true,
    },

    // Retire: always shown for Active; disabled when occupied, assigned, or preparing
    status === "Active" && {
      name: "Retire",
      value: "retire",
      icon: "icons/dropdown/activate.svg",
      disabled: retireBlocked,
      disabledTooltip: retireBlocked ? RETIRE_BLOCKED_TOOLTIP : undefined,
    },

    // Reactivate/Archive: status = Retired
    status === "Retired" && {
      name: "Reactivate",
      value: "reactivate",
      icon: "icons/dropdown/activate.svg",
    },

    // Hidden when archived
    !isArchived && { name: "Attach Role", value: "attachRole", icon: "icons/dropdown/attach.svg" },
    { name: "Rename", value: "rename", icon: "icons/dropdown/rename.svg" },
    !isArchived && { name: "Clone", value: "clone", icon: "icons/dropdown/copy-02.svg" },

    // Archive/Unarchive
    status === "Retired" && {
      name: "Archive",
      value: "archive",
      icon: "icons/dropdown/archive-new.svg",
    },
    status === "Archived" && {
      name: "Unarchive",
      value: "unarchive",
      icon: "icons/dropdown/activate.svg",
    },
  ].filter(Boolean);
});

function handleMenuClick(item) {
  if (item && item.value && !item.disabled) {
    emit("action", { type: item.value, position: props.position });
  }
}
</script>
<style scoped>
.position-line-menu {
  width: 20%;
  text-align: end;
}
</style>
